(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swirla-cart"]) return;
  try {
    
document.querySelectorAll('.sr-pink-cart [data-quantity-step]').forEach(button => {
  button.addEventListener('click', () => {
    const form = button.closest('form');
    const input = button.parentElement.querySelector('input');
    input.value = Math.max(0, Number(input.value) + Number(button.dataset.quantityStep));
    form.requestSubmit(form.querySelector('[data-cart-update]'));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swirla-offer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const button=event.target.closest('.sw-offer-pause');
  if(!button)return;
  const paused=button.closest('[data-sw-offer]').classList.toggle('is-paused');
  button.setAttribute('aria-pressed',String(paused));
  button.setAttribute('aria-label',paused?button.dataset.resumeLabel:button.dataset.pauseLabel);
  button.querySelector('span').textContent=paused?'▶':'Ⅱ';
});

  } catch(e) { console.error(e); }
})();
})();
